// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import {
  Carousel,
  CarouselItem,
  Form,
  FormItem,
  Button,
  Select,
  Input,
  Option,
  Message,
  Pagination,
  Divider,
  Empty
} from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import wow from 'wowjs'
import { timestampToTime } from '@/assets/js'
import * as echarts from 'echarts'
import lodash from 'lodash'
import 'animate.css'
import axios from 'axios'

Vue.prototype.$wow = wow
Vue.prototype.Axios=axios
axios.defaults.baseURL='https://www.chinaindustria.com';
// axios.defaults.baseURL='http://localhost:1111';
// axios.defaults.baseURL='http://hjf:8100';
Vue.config.productionTip = false
Vue.use(Carousel)
Vue.use(CarouselItem)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Button)
Vue.use(Select)
Vue.use(Option)
Vue.use(Pagination)
Vue.use(Input)
Vue.use(Divider)
Vue.use(Empty)
Vue.prototype.$message = Message
Vue.prototype.$echarts = echarts
Vue.prototype.$lodash = lodash

Vue.filter('formatDateLong', function (v) {
  return timestampToTime(v)
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
})



// WEBPACK FOOTER //
// ./src/main.js